import React from "react"
import AsyncSelect from "react-select/lib/Async";
import {IoIosAddCircle, IoMdArrowDropdown, IoIosCloseCircle, IoMdArrowDropup} from "react-icons/io"
import ApiService from "../../../Services/ApiService.js"
import Papa from "papaparse"
import ReactTable from "react-table";
import AlertService from "../../../Services/AlertService";
import BidModal from "./bidModal";

class Metrics extends React.Component {

    state = {
        campaign_companies: [],
        client_companies: [],
        common_names: [],
        hide_accounts: false,
        account_id_input: -1,
        account_common_name_input : '',
        client_id: '',
        campaign_id: '',
        table_data: [],
        table_loading: false,
        selected_company: '',
    };

    componentDidMount = () => {
        if (this.props.data) {
            this.setState({
                ...this.state,
                client_id: this.props.data.clientId,
                campaign_id: this.props.data.campaignId
            }, () => {
                this.fetchCampaignCompanies();
                
            });
        }
    };

    fetchCampaignCompanies = () => {
        let campaign_id = this.props.data.campaignId;
        ApiService.get('/api/campaigns/linkedin-companies?campaign_id=' + campaign_id).then(response => {
            var companies = this.getLinkedInLocalizedNames(response.data.Companies);
            
            this.setState({
                campaign_companies: response.data.Companies,
                client_companies: companies,
            }, () => {
                this.setState({
                    table_data: this.buildTableData()
                });
            });
            
        });
    };
    
    buildTableData = () => {
        let data = JSON.parse(JSON.stringify(this.state.campaign_companies));

        for (let i = 0; i < data.length; i++) {
            data[i]['active'] = false;
        }
        return data;
    };

    getLinkedInLocalizedNames = (Companies) => {
        var companies = [];
        if (Companies.length > 0) {
            for (var i = 0; i < Companies.length; i++) {
                var newelement = {id: Companies[i].linkedin_company_id, localizedName: Companies[i].default_name};
                companies.push(newelement);
            }
        }
        return companies;
    };

    showModal(linkedinCompanyID)
    {
        let modal = document.getElementById("bid-modal");
        this.setState({...this.state, selected_company: linkedinCompanyID}, () => {
            modal.style.display = "block";
        });
    }

    hideModal() {
        let modal = document.getElementById("bid-modal");
        modal.style.display = "none";
    }

    updateAccountAdAnalytics = () => {
        var response = ApiService.get('/api/campaigns/fetch-campaign-ad-reporting?campaign_id=' + this.state.campaign_id)
            .then(data => {
                this.fetchCampaignCompanies();
                AlertService.success('Successfully updated account ad analytics information');
            })
            .catch(ex => {
                AlertService.error('Failed to update account ad analytics information');
            })
    }

    render() {
        
        const columns = [
            {
                Header: "Account Name",
                accessor: "default_name",
                width: 150
            },
            {
                Header: "Common Name",
                accessor: "common_name",
                width: 150
            },
            {
                Header: "Clicks",
                accessor: 'clicks',
                style: {'whiteSpace': 'unset'},
                width: 150
            },
            {
                Header: "Avg CTR (%)",
                accessor: 'ctr',
                style: {'whiteSpace': 'unset'},
                width: 150
            },
            {
                Header: "Bid ($)",
                accessor: 'bid_amount',
                style: {'whiteSpace': 'unset'},
                width: 150,
                Cell: (data) => {
                    var linkedin_company_id = data.row._original.linkedin_company_id;
                    return(
                        <div>
                            <a className="bid-amount" onClick={() => this.showModal(linkedin_company_id)}>{data.row._original.bid_amount}</a>
                        </div>
                    )
                }
            },
            {
                Header: "Avg CPC ($)",
                accessor: 'cpc',
                style: {'whiteSpace': 'unset'},
                width: 150
            },
        ];
        
        let $metricsListing = null;
        if (this.state.table_data.length !== 0) {
            $metricsListing = (
                <ReactTable
            loading={this.state.table_loading}
            data={this.state.table_data}
            columns={columns}
            showPagination={true}
            minRows={0}
            defaultPageSize={100}
            resizable={false}
            />
            )
        }

        return(
            <div className="accounts-ads">
                <div className="body" hidden={this.state.hide_accounts}>
                    <div>
                        <button onClick={this.updateAccountAdAnalytics}>Update Ad Analytics</button>
                    </div>
                    <div className="table-style">
                        {$metricsListing}
                    </div>
                </div>
                <BidModal
                    onClose={this.hideModal.bind(this)}
                    campaignID={this.state.campaign_id}
                    companyID={this.state.selected_company}
                    fetchCompanies={this.fetchCampaignCompanies.bind(this)}
                />
            </div>
        )
    }
}

export default Metrics;